export default {
  computed: {
    topupSources() {
      return [
        { text: this.$t("company"), value: "company" },
        { text: this.$t("employee"), value: "employee" },
      ];
    },
    topupTypes() {
      return [
        { text: this.$t("daily_subsidy"), value: "daily_subsidy" },
        { text: this.$t("personal_payment"), value: "personal_payment" },
        { text: this.$t("bonus"), value: "bonus" },
        { text: this.$t("compensation"), value: "compensation" },
      ];
    },
    paymentMethods() {
      return [
        { text: this.$t("automatic"), value: "automatic" },
        { text: this.$t("card"), value: "card" },
        { text: this.$t("cash"), value: "cash" },
        { text: this.$t("bank_transfer"), value: "bank_transfer" },
      ];
    },
  },
};
